import { createStore } from 'vuex'
import Tabs from '@/store/Tabs';
import Modal from '@/store/Modal';
import Notifications from '@/store/Notifications';
import Loading from '@/store/Loading';
//COMMON
import ManageUser from '@/store/common/ManageUser';
//API
import Authentication from '@/store/API/authentication';
import Common from '@/store/API/common';
// - CommercialConfig
import AccountExecutive from '@/store/API/CommercialConfig/accountExecutive';
import ClientCategory from '@/store/API/CommercialConfig/clientCategory';
import AdAgency from '@/store/API/CommercialConfig/adAgency';
import AdAgencyGroup from '@/store/API/CommercialConfig/adAgencyGroup';
import PayMethod from '@/store/API/CommercialConfig/payMethod';
import Origin from '@/store/API/CommercialConfig/origin';
import BusinessUnit from '@/store/API/CommercialConfig/businessUnit';
import Product from '@/store/API/CommercialConfig/product';
import SpotCategory from '@/store/API/CommercialConfig/spotCategory';
// - StationConfig
import Station from '@/store/API/StationConfig/station';
import Speaker from '@/store/API/StationConfig/speaker';
import Show from '@/store/API/StationConfig/show';
import Schedule from '@/store/API/StationConfig/schedule';
// - SpotProgramming
import Certify from '@/store/API/SpotProgramming/certify';
import Client from '@/store/API/SpotProgramming/client';
import Spot from '@/store/API/SpotProgramming/spot';
import TrafficLog from '@/store/API/SpotProgramming/trafficLog';
import TrafficLogFile from '@/store/API/SpotProgramming/trafficLogFile';
// - Settings
import Importer from '@/store/API/Settings/importer';
// - Report
import Report from '@/store/API/Report/report';

export default createStore({
  modules: {
    Tabs,
    Modal,
    Notifications,
    Loading,
    //COMMON
    ManageUser,
    Common,
    // API
    Authentication,
    AccountExecutive,
    ClientCategory,
    AdAgency,
    AdAgencyGroup,
    PayMethod,
    Origin,
    BusinessUnit,
    Station,
    Speaker,
    Show,
    Schedule,
    Certify,
    Client,
    Product,
    SpotCategory,
    Spot,
    TrafficLog,
    TrafficLogFile,
    Importer,
    Report
  }
})
